import { PurchaseDetail, PurchaseFormValues } from "../../../types/purchases/BasePurchase";

export function mapDefaultPurchase(purchase: PurchaseDetail): PurchaseFormValues {
  return {
    id: purchase.id,
    documentNumber: purchase.documentNumber,
    purchaseDate: purchase.purchaseDate,
    supplier: purchase.supplier,
    documentType: purchase.documentType,
    comments: purchase.comments || '',
    cancellationReason: purchase.cancellationReason || '',
    products: [], // Por si acaso
  };
}
